import { Directive, EventEmitter, HostListener, Injector, Input, Output, } from '@angular/core';
import { NgModel } from '@angular/forms';
import { TemplateUuids, isIframeClick } from '@mhe/ngx-shared/utils';
import { isValid, parse } from 'date-fns';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DatepickerCalendarComponent } from './datepicker-calendar.component';
import { DatepickerOptions } from './datepicker.options';
import * as i0 from "@angular/core";
import * as i1 from "@angular/forms";
/** @deprecated use component for a11y compliance */
export class DatepickerDirective {
    constructor(elementRef, resolver, viewContainerRef, renderer, ngModel) {
        this.elementRef = elementRef;
        this.resolver = resolver;
        this.viewContainerRef = viewContainerRef;
        this.renderer = renderer;
        this.ngModel = ngModel;
        this.closeOnBlur = false;
        this.isOpened = true;
        this.position = 'bottom-right';
        this.dateChange = new EventEmitter();
        this.templateUuids = new TemplateUuids();
        this.calendarRef = null;
        this.destroy$ = new Subject();
        this.elementRef.nativeElement.autocomplete = 'off';
        console.warn('ngx-shared Deprecation Warning\n\nThe mheDatepicker directive is deprecated. Please use the mhe-datepicker component for WCAG2.1-AA compliance');
    }
    toggle() {
        if (this.calendarRef !== null) {
            this.calendarRef.instance.onClose();
        }
        else {
            this.initPicker();
        }
    }
    ngOnInit() {
        if (this.ngModel && this.ngModel.valueChanges) {
            this.ngModel.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((val) => {
                this.setDatepickerValue(val);
            });
        }
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.unsubscribe();
    }
    initPicker() {
        const currentValue = (this.currentValue && parse(this.currentValue)) || parse(this.elementRef.nativeElement.value);
        this.calendarRef = this.createDatePicker();
        this.calendarRef.instance.selectedValue = isValid(currentValue) ? currentValue : new Date();
        this.renderer.setAttribute(this.elementRef.nativeElement, 'aria-describedby', this.templateUuids.get('datepicker-calendar'));
    }
    setDatepickerValue(value) {
        this.currentValue = value;
        this.ngModel.update.emit(this.currentValue);
    }
    close() {
        if (this.calendarRef) {
            this.renderer.removeAttribute(this.elementRef.nativeElement, 'aria-describedby');
            this.viewContainerRef.remove();
            this.calendarRef = null;
        }
    }
    onClickedOutside(event) {
        if ((this.closeOnBlur && isIframeClick(event)) || !this.elementRef.nativeElement.contains(event.target)) {
            this.close();
        }
    }
    onDateChange(dateSelectedEvent) {
        if (dateSelectedEvent.valid) {
            this.ngModel.update.emit(dateSelectedEvent.dateString);
            this.dateChange.emit(dateSelectedEvent);
            this.elementRef.nativeElement.value = dateSelectedEvent.dateString;
            this.close();
        }
    }
    createDatePicker() {
        const options = this.getOptions();
        const index = this.viewContainerRef.length;
        const injector = Injector.create({
            parent: this.viewContainerRef.injector,
            providers: [{ provide: DatepickerOptions, useValue: options }],
        });
        const ref = this.viewContainerRef.createComponent(DatepickerCalendarComponent, { index, injector });
        return ref;
    }
    getOptions() {
        const options = new DatepickerOptions();
        return Object.assign(Object.assign({}, options), { dateFormat: this.dateFormat, id: this.templateUuids.get('datepicker-calendar'), onDateChange: (dateSelectionEvent) => {
                this.onDateChange(dateSelectionEvent);
            }, close: () => {
                this.close();
            } });
    }
}
DatepickerDirective.ɵfac = function DatepickerDirective_Factory(t) { return new (t || DatepickerDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ComponentFactoryResolver), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i1.NgModel)); };
DatepickerDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: DatepickerDirective, selectors: [["input", "mheDatepicker", ""]], hostBindings: function DatepickerDirective_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("click", function DatepickerDirective_click_HostBindingHandler() { return ctx.toggle(); });
    } }, inputs: { closeOnBlur: "closeOnBlur", options: "options", dateFormat: "dateFormat", isOpened: "isOpened", position: "position" }, outputs: { dateChange: "dateChange" }, exportAs: ["mheDatepicker"], features: [i0.ɵɵProvidersFeature([NgModel])] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DatepickerDirective, [{
        type: Directive,
        args: [{
                selector: 'input[mheDatepicker]',
                providers: [NgModel],
                exportAs: 'mheDatepicker',
            }]
    }], function () { return [{ type: i0.ElementRef }, { type: i0.ComponentFactoryResolver }, { type: i0.ViewContainerRef }, { type: i0.Renderer2 }, { type: i1.NgModel }]; }, { closeOnBlur: [{
            type: Input
        }], options: [{
            type: Input
        }], dateFormat: [{
            type: Input
        }], isOpened: [{
            type: Input
        }], position: [{
            type: Input
        }], dateChange: [{
            type: Output
        }], toggle: [{
            type: HostListener,
            args: ['click']
        }] }); })();
